import React from 'react';
import { framework } from 'saffroncodejs';
import Config from '../../Core/Config.js';
import Axios from 'axios';
import UserManager from '../../Core/UserManager';
import { Button, Form, FormGroup, Label, Input, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './Pishnehadha.css';
var PageManager = framework.PageManager;
var $ = require('jquery');
var sendMessageModel={
    Email:"",
    Phone: "", 
    FullName: "",
    Subject: "", 
    Body:"", 
    UserId: "",
}
class Pishnehadha extends React.Component {

    constructor(props) {
        super(props);
        this.toggle2 = this.toggle2.bind(this);
        this.goToHome=this.goToHome.bind(this);
        this.state = {
            Email: "",
            Phone: "",
            FullName: "",
            Subject: "",
            Body: "",
            UserId: "",
            modal: false,
            isOpen: false,
            nestedModal: false,
            closeAll: false,
            userProfileInfo:[],
        };
        this.setEmail = this.setEmail.bind(this);
        this.setPhone = this.setPhone.bind(this);
        this.setFullName = this.setFullName.bind(this);
        this.setSubject = this.setSubject.bind(this);
        this.setBody = this.setBody.bind(this);
        this.setUserId = this.setUserId.bind(this);
        this.loadProfile();
    }

    componentWillReceiveProps(props) {
        this.loadDetail();
        
    }
    loadProfile(){
        Axios.get(Config.domain_pic + "/GetUsersProfile?" +
            "LanguageBaseId=" + 11 + "&UserId=" + UserManager.getUserToken()+ "&OtherUserId=" +UserManager.getUserToken()
        )
            .then((result) => {
                // console.log("result.userprofile: ", JSON.stringify(result.data));
                this.setState({ userProfileInfo: result.data, isLoading: false
                });

            })
            .catch((error) => {
                alert(error) 
            })
    }
    loadDetail(EAddress, MNo, FullName) {
        if(this.state.Subject === "" || this.state.Body===""){
            $('#exampleSubject').addClass('num_redline');
            $('#exampleSubject').removeClass('num_line');
        
            $('#exampleBody').addClass('num_redline');
            $('#exampleBody').removeClass('num_line');
        }
        else{
            sendMessageModel.Email=EAddress;
            sendMessageModel.Phone=MNo;
            sendMessageModel.FullName=FullName;
            sendMessageModel.Subject=this.state.Subject;
            sendMessageModel.Body=this.state.Body;
            sendMessageModel.UserId=UserManager.getUserToken();
            Axios.post(Config.domain_pic + "/RegisterQuetion",sendMessageModel
            )
                .then((result) => {
                    // console.log("result.data: ", JSON.stringify(result.data));
                    this.setState({ data: result.data, isloading: false });
                    this.toggle2();
                    $('#exampleSubject').addClass('num_line');
                    $('#exampleSubject').removeClass('num_redline');
                
                    $('#exampleBody').addClass('num_line');
                    $('#exampleBody').removeClass('num_redline');
    
                }
                )
              
            
        }
        
    }

    setEmail(event) {
        this.setState({ Email: event.target.value });
    }

    setPhone(event) {
        this.setState({ Phone: event.target.value });
    }

    setFullName(event) {
        this.setState({ FullName: event.target.value });
    }

    setSubject(event) {
        this.setState({ Subject: event.target.value });
        $('#exampleSubject').addClass('num_line');
        $('#exampleSubject').removeClass('num_redline');
    
        $('#exampleBody').addClass('num_line');
        $('#exampleBody').removeClass('num_redline');
    }

    setBody(event) {
        this.setState({ Body: event.target.value });
        $('#exampleSubject').addClass('num_line');
        $('#exampleSubject').removeClass('num_redline');
    
        $('#exampleBody').addClass('num_line');
        $('#exampleBody').removeClass('num_redline');
    }

    setUserId(event) {
        this.setState({ UserId: event.target.value });
    }
    toggle2() {
        this.setState({
            modal: !this.state.modal
        });
    }
    goToHome(){
        if(this.state.Email!=="" && this.state.Phone!=="" && this.state.FullName!=="" && this.state.Subject!=="" &&  this.state.Body!==""){
        PageManager.changePage(Config.p_home);
    }
    else{
        this.toggle2();
    }
    }
    render() {
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>پیشنهادات و انتقادات</h4>
                    </Col>
                </Row>

                <div className="Pishnehadha-form">
 {/* Modal */}
 
        <Modal isOpen={this.state.modal} toggle={this.toggle2}  className="alert_phishnahadha">
          <ModalHeader toggle={this.toggle2}></ModalHeader>
          <ModalBody>
          گزارش شما با موفقیت ارسال گردید
            
          </ModalBody>
          <ModalFooter>
            <Button  color="primary" onClick={this.goToHome}>بستن </Button>
          </ModalFooter>
        </Modal>
        {/* Modal */}
                    <div className="container-fluid Inquiry">
                        <div className="container">
                            <Form >
                            {this.state.userProfileInfo.slice(0,1).map((p)=>
                           {
                            return(
                                <span>
                                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                        <Label for="exampleNumber " sm={3} >آدرس ایمیل</Label>
                                        <Col sm={9}>
                                            <Input type="text"  value={p.EMailAddress} onLoad={this.setEmail} FullName="Email" id="exampleEmail" placeholder={p.EmailAddress} disabled />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                        <Label for="exampleNumber" sm={3}>تلفن:</Label>
                                        <Col sm={9}>
                                            <Input type="text" pattern="[0-9]*" value={p.MobileNo} FullName="Phone" onLoad={this.setPhone} id="examplePhone" placeholder={p.MobileNo} disabled />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                        <Label for="exampleNumber" sm={3}>نام و نام خانوادگی</Label>
                                        <Col sm={9}>
                                            <Input type="text"  value={p.FirstName+' '+p.LastName} FullName="FullName" onLoad={this.setFullName} id="exampleFullName" placeholder={p.FirstName+'&nbsp;'+p.LastName}   disabled/>
                                        </Col>
                                    </FormGroup>
                                
                            
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                    <Label for="exampleNumber" sm={3}>موضوع</Label>
                                    <Col sm={9}>
                                        <Input type="text" value={this.state.Subject} FullName="Subject" onChange={this.setSubject} id="exampleSubject" placeholder="" />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                    <Label for="exampleNumber" sm={3}>پیشنهاد/انتقاد</Label>
                                    <Col sm={9}>
                                        <Input type="text"  value={this.state.Body} FullName="Body" onChange={this.setBody} id="exampleBody" placeholder="" />
                                    </Col>
                                </FormGroup>
                                <br />
                                <div className="buttons">

                                    <Button onClick={(
                                    ) => {
                                        this.loadDetail(p.EMailAddress, p.MobileNo, p.FirstName+' '+p.LastName)}}>
                                        ارسال</Button>
                                        


                                </div>
                                </span>
                                )
                            } 
                                 
                             )}
                                <br />
                                <br />
                            </Form>
                            
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default Pishnehadha;


// WEBPACK FOOTER //
// ./src/components/PishnehadEnteghad/Pishnehadha.js